import { Component, OnInit } from '@angular/core';
import { PaymentService, TrunkShowEvent } from '@services/payment.service';
import { NotificationService } from '@services/notification.service';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-trunk-show-manager',
  templateUrl: './trunk-show-manager.component.html',
  styleUrls: ['./trunk-show-manager.component.css'],
})
export class TrunkShowManagerComponent implements OnInit {
  events: TrunkShowEvent[] = [];
  saving = false;
  draft: TrunkShowEvent = {
    name: '',
    vendorName: '',
    discountPercent: 0,
    notes: '',
  };

  constructor(
    private paymentService: PaymentService,
    private notification: NotificationService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.draft.store = this.storeId();
    this.load();
  }

  load(): void {
    this.paymentService.listTrunkShows().subscribe((events) => {
      this.events = events || [];
    });
  }

  save(event: TrunkShowEvent): void {
    this.saving = true;
    this.paymentService.saveTrunkShow(event).subscribe({
      next: () => {
        this.saving = false;
        this.notification.show('success', 'Trunk show saved');
        this.load();
      },
      error: () => {
        this.saving = false;
        this.notification.show('error', 'Could not save trunk show');
      },
    });
  }

  add(): void {
    if (!this.draft.name) {
      return;
    }
    this.save({ ...this.draft, store: this.storeId() });
    this.draft = {
      name: '',
      vendorName: '',
      discountPercent: 0,
      notes: '',
      store: this.storeId(),
    };
  }

  private storeId(): number {
    const store = Number(this.auth.getStore());
    return isNaN(store) ? 0 : store;
  }

  toInputDate(value: string | Date): string {
    if (!value) {
      return '';
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toISOString().slice(0, 10);
  }
}
